module.exports = __webpack_public_path__ + "static/img/004.f8c2b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/004.png
// module id = kCGk
// module chunks = 1